import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashThinIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14.8 16.1",
	style: { enableBackground: "new 0 0 14.8 16.1" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.trash-thin-icon-st1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "trash-thin-icon-st1",
			d: "M14.3,3.1H0.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "trash-thin-icon-st1",
			d: "M5.5,6.8v5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "trash-thin-icon-st1",
			d: "M9.3,6.8v5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "trash-thin-icon-st1",
			d: "M13,3.1V15c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2h-10c-0.2,0-0.3-0.1-0.4-0.2S1.8,15.1,1.8,15V3.1 "
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "trash-thin-icon-st1",
			d: "M10.5,3.1V1.8c0-0.3-0.1-0.6-0.4-0.9C9.9,0.7,9.5,0.5,9.2,0.5H5.5C5.2,0.6,4.9,0.7,4.6,0.9 C4.4,1.2,4.3,1.5,4.3,1.8V3"
		})
	] })]
});
export default SvgTrashThinIcon;
